import { notification } from 'antd'
import { useEffect, useLayoutEffect, useState } from 'react'
import { EAlertTypes } from '../../enums/EAlertTypes'
import { displayMessage } from '../../helpers/messages'
import api from '../../services/api'
import { GeneralContext } from './GeneralContext'

// Mantem uma variável atualizada com as dimensoes da tela
const useWindowSize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight])

    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight])
        }

        window.addEventListener('resize', updateSize)
        updateSize()
        return () => window.removeEventListener('resize', updateSize)
    }, [])

    return size
}

const maxWidthMobileMode = 700 //px
const minWidthBigScreenMode = 1280

export function GeneralContextProvider({ children }) {
    const [windowWidth, windowHeight] = useWindowSize()
    const [showLoading, setShowLoading] = useState(false)
    const [notify, contextHolder] = notification.useNotification()
    const [enums, setEnums] = useState(null)

    useEffect(() => {
        listEnums()
    }, [])
    

    async function listEnums() {
        setShowLoading(true)
        try {
            const { data } = await api.enums.list()
            setEnums(data)
        } catch (error) {
            console.error(error.message)
        } finally {
            setShowLoading(false)
        }
    }

    const showAlert = (descriptionMessage = null, type = EAlertTypes.ERROR, title = null, duration = 5) => {
        const description = descriptionMessage ? (displayMessage(descriptionMessage)?.length > 0 ? displayMessage(descriptionMessage) : descriptionMessage) : ''
        const titleMsg = title ?? type.defaultTitle

        notify[type.param]({
            description,
            duration,
            message: titleMsg,
        })
    }

    const mobile_mode = windowWidth <= maxWidthMobileMode
    const big_screen_mode = windowWidth >= minWidthBigScreenMode

    return (
        <>
            {contextHolder}

            <GeneralContext.Provider
                value={{
                    showLoading,
                    setShowLoading,
                    enums,
                    setEnums,
                    windowWidth,
                    windowHeight,
                    mobile_mode,
                    big_screen_mode,
                    showAlert,
                }}
            >
                {children}
            </GeneralContext.Provider>
        </>
    )
}
